import React from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ConfirmModal from '@/common/containers/Modals/ConfirmModal/index';
import { Notification } from '@/common/utils/index';
import { routes } from '@/app/routing/index';
import { useDeleteResellerMutation } from '@/entities/admin-resellers';

const DeleteReseller = ({ resellerId, disabled = false }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const mutation = useDeleteResellerMutation({
    onSuccess: () => {
      Notification.success(t('Reseller deleted successfully'));
      history.push(routes.adminPanel.resellers);
    },
    onError: (error) => {
      const responseMessage = error?.response?.data?.message;
      const message = Array.isArray(responseMessage)
        ? responseMessage[0]
        : responseMessage;

      Notification.error(
        message?.includes('registration_code') || message?.includes('FK_')
          ? t('This reseller cannot be deleted because it has access codes')
          : t('Failed to delete reseller')
      );
    },
  });

  return (
    <ConfirmModal
      type="delete"
      title={t('Delete reseller?')}
      description={t(
        'Are you sure you want to delete this reseller? This action can’t be undone.'
      )}
      cancelText={t('Cancel')}
      confirmText={t('Delete')}
    >
      {(confirm) => (
        <Button
          type="button"
          variant="contained"
          color="error"
          disabled={disabled || mutation.isPending}
          loading={mutation.isPending}
          onClick={confirm(() => mutation.mutate(resellerId))}
          sx={{ width: 'fit-content' }}
        >
          {t('Delete reseller')}
        </Button>
      )}
    </ConfirmModal>
  );
};

export default DeleteReseller;
